<template>
    <div class="product-center-detail-container">
        <div class="banner-style">
            <!-- <img src="../../assets/image/developerPlatform/banner-bg.png" alt=""> -->
            <img :src="bannerUrl" alt="">
        </div>

        <div class="procedure-style pub-style">
            <div class="content-wrap">
                <div class="content" v-for="(item,index) in programList" :key="index">
                    <div class="left">
                        <img width="156" :src="item.imgUrl" alt="">
                    </div>
                    <div class="right">
                        <div class="title font-bold">{{item.title}}</div>
                        <div class="txt">{{item.content}}</div>
                    
                    </div>
                </div>
            </div>
        </div>

        <div class="use-style pub-style">
            <div class="content-wrap">
                <div class="h1 font-bold">{{$t('about.useTitle')}}</div>
                <div class="txt">{{$t('about.useContent')}}</div>
                <div class="txt" v-if="locale === 'en'" style="margin-top: 10px;">{{$t('about.useContent2')}}</div>
                <div class="txt" v-if="locale === 'en'" style="margin-top: 10px;">{{$t('about.useContent3')}}</div>
                <div class="txt" v-if="locale === 'en'" style="margin-top: 10px;">{{$t('about.useContent4')}}</div>
            </div>
        </div>

        <div class="sence-style pub-style">
            <div class="content-wrap">
                <div class="h1 font-bold">{{$t('about.senceTitile')}}</div>
                <div class="sub-t font-bold">{{$t('about.senceContent')}}</div>
                <div class="exp">{{$t('about.senceDesc')}}</div>
                <div class="content" v-for="(item,index) in senceList" :key="index">
                    <div class="left">
                        <img width="156" :src="item.imgUrl" alt="">
                    </div>
                    <div class="right">
                        <div class="title font-bold">{{ item.title }}</div>
                        <div class="txt">{{ item.content }}</div>
                    
                    </div>
                </div>
            </div>
        </div>

        <div class="bottom-banner pub-style">
            <div class="content-wrap">
                <div class="h1 font-bold">{{$t('about.bottomBanTitle')}}</div>
                <div class="sub-t font-bold">{{$t('about.bottomBanContent')}}</div>
                <div class="exp">{{$t('about.bottomBanDesc')}}</div>
            </div>
        </div>


    </div>
</template>

<script setup>
import { qiniuImgOffWebUrl } from '@/config'
import { getAboutUs } from '@/api/developer'
import { onMounted, computed, ref } from 'vue';
import { useI18n } from "vue-i18n";
const { locale, t } = useI18n();

const bannerUrl = ref('')
onMounted(async () =>{
    getAboutdetail()
})

const programList = computed(() => {
    const data = [];
    for (let i = 1; i < 5; i++) {
        data.push({
            imgUrl: qiniuImgOffWebUrl + '/developer/2-'+ i+'.png',
            title: t("about.programTitle_" + i),
            content: t("about.programContent_" + i),
        });
    }
    return data;
})

const senceList = computed(() => {
    const data = [];
    for (let i = 1; i < 4; i++) {
        data.push({
            imgUrl: qiniuImgOffWebUrl + '/developer/4-'+ i+'.png',
            title: t("about.senceTitle_" + i),
            content: t("about.senceContent_" + i),
        });
    }
    return data;
})


const getAboutdetail = async () => {
    getAboutUs().then(res => {
        if (res.code === 200) {
            bannerUrl.value = res.result.topBanner.iconUrl
        }

    }).catch(err => { console.log(err); })
}

</script>

<style lang="scss" scoped>

.product-center-detail-container{
    width: 100%;

    .banner-style{
        width: 100%;
        display: flex;
        justify-content: center;
        max-width: 100%;

        img{
            width: 100%;
        }
    }

    .procedure-style {
        width: 100%;
        height: 1046px;
        background: linear-gradient(308.07deg, #000000 27.14%, #353A43 87.81%),
                    linear-gradient(308.07deg, #000000 27.14%, rgba(35, 35, 35, 0.69) 88.03%),
                    linear-gradient(180deg, #232323 0%, rgba(35, 35, 35, 0) 100%);

        .content{
            align-items: center;
        }
    }

    .pub-style{
        .content-wrap{
             width: 1140px;  
             margin: 0 auto; 
             padding: 25px 0 100px;

             .content{
                display: flex;
                align-items: center;
                margin-top: 75px;
             }

             .h1{
                font-size: 32px;
                color: #fff;
            }

             .sub-t{
                margin-top: 48px;
                font-size: 20px;
                color: #fff;
            }
            .exp{
                margin-top: 12px;
                font-size: 12px;
                color: #fff;
            }
        }

        .right{
            margin-left: 48px;
            .title{
                color: rgba(69, 99, 255, 0.77);
                font-size: 32px;
            }
            .txt{
                color: #fff;
                font-size: 20px;
            }
        }
    }


    .use-style{
        width: 100%;
        height: 764px;
        background: url(https://img.gotokepler.com/image/gotokepler/developer/3.jpg) no-repeat center;
        background-size: cover;
        .h1{
            padding-top: 55px;
            margin-bottom: 48px;
        }

        .txt{
            color: #fff;
            font-size: 20px; 
        }

    }

    .sence-style{
        width: 100%;
        height: 1060px;
        background: linear-gradient(308.07deg, #000000 27.14%, #353A43 87.81%),
                    linear-gradient(308.07deg, #000000 27.14%, rgba(35, 35, 35, 0.69) 88.03%),
                    linear-gradient(180deg, #232323 0%, rgba(35, 35, 35, 0) 100%);

        .content{
            margin-top: 72px!important;
        }

        .h1{
            padding-top: 75px;
        }

    }

    .bottom-banner{
        width: 100%;
        height: 640px;
        background: url(https://img.gotokepler.com/image/gotokepler/developer/5.jpg) no-repeat center;
        background-size: cover;

        .h1{
            padding-top: 195px;
        }
    }
}
</style>